import { serviceHost } from "../../../common/const";
import ServiceRequest from "../../../utils/service-request";

export const getKycAccessRightsEntitlements = async () => {
  try {
    let accessRightResp = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/accessrights"
    );
    return { accessRightResp, err: null };
  } catch (err) {
    if (err) {
      return { accessRightResp: null, err };
    }
  }
};

export const getAccessRightsById = async (Id) => {
  let data = { userId: "" + Id + "" };

  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/accessrights/get",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveUserAccessRights = async (userAccessRights) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/accessrights/save",
      userAccessRights
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getUserAppLevelAccessRights = async (userId) => {
  try {
    let data = { userId: userId };

    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/appLevelAccessRight/get",
      data
    );

    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
